import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useState } from "react";
import { SystemNotificationViewModel } from "./SystemNotifications.types";

export default function useSystemNotificationHooks() {
    const [showDialog, setShowDialog] = useState(false);
    const [systemNotificationForEdit, setSystemNotificationForEdit] = useState<SystemNotificationViewModel | undefined>(undefined);

    let { isLoading, data, refetch } = useDotLegalQuery<Array<SystemNotificationViewModel>>("/systemNotifications");

    return {
        systemNotificationForEdit,
        setSystemNotificationForEdit,
        showDialog,
        setShowDialog,
        isLoading,
        data,
        refetch,
    };
}
